
export interface IOneTimeScopeChangeTandC {
    id?: number;
    crsId?: number;
    description?: string;
    requestedBy?: string;
    confirmedBy?: string;
    isRequested?: boolean;
    isConfirmed?: boolean;
    isRequestedByClient?: boolean;
    scopeId?: number;
    certificateRequestId?: number;
}

export class OneTimeScopeChangeTandC implements IOneTimeScopeChangeTandC {

    constructor(
        public id?: number,
        public crsId?: number,
        public description?: string,
        public requestedBy?: string,
        public confirmedBy?: string,
        public isRequested?: boolean,
        public isConfirmed?: boolean,
        public isRequestedByClient?: boolean,
        public scopeId?: number,
        public certificateRequestId?: number,
    ) {
        this.isRequested = false;
        this.isConfirmed = false;
        this.isRequestedByClient = false;
    }
    
}


export class VesselUnknownDTO {
    vesselName?: any;
    imoNumber?: any;
    isFirstClassVesselSelected?: boolean;
    voyageNumber?: any;
}